const imports = [
    { selector: "#user_register", module: () => require('../register/user_register.js') },
    { selector: "#user_profile", module: () => require('../profile/user_profile.js') },
];

imports.forEach(item => {
    if ($(item.selector).length > 0) {
        item.module();
    }
});
